/* Iter122du · SuperAdmin · Estremi bonifico modificabili (pagina pubblica /piani legge da qui). */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Landmark, Save } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export default function SuperAdminBonifico() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/superadmin/bonifico-settings").then((r) => setForm(r.data)).catch(() => toast.error("Errore caricamento estremi bonifico"));
  }, []);

  const salva = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/superadmin/bonifico-settings", {
        intestatario: form.intestatario, iban: form.iban, bic_swift: form.bic_swift,
        banca: form.banca, causale_template: form.causale_template,
        note: form.note, email_contabile: form.email_contabile,
      });
      setForm(data);
      toast.success("Estremi bonifico aggiornati — visibili subito in pagina /piani");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Salvataggio non riuscito"); }
    setBusy(false);
  };

  if (!form) return <div className="text-slate-500">Caricamento…</div>;
  return (
    <div className="space-y-4" data-testid="superadmin-bonifico">
      <div className="flex items-center gap-2">
        <Landmark className="w-5 h-5 text-brand" />
        <h3 className="font-display text-lg font-bold text-slate-800">Estremi bonifico</h3>
      </div>
      <Card className="p-3 bg-slate-50 border-2 border-slate-200 text-xs text-slate-600">
        Questi dati sono visibili pubblicamente nella pagina <code className="bg-white px-1 rounded">/piani</code>
        (istruzioni per il pagamento bonifico) e nel PDF del listino. Aggiornali con cura.
      </Card>
      <Card className="p-5 border-2 max-w-3xl">
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Intestatario</Label>
            <Input data-testid="bonifico-intestatario" value={form.intestatario || ""}
              onChange={(e) => setForm({ ...form, intestatario: e.target.value })} className="mt-1" />
          </div>
          <div>
            <Label>Banca</Label>
            <Input data-testid="bonifico-banca" value={form.banca || ""}
              onChange={(e) => setForm({ ...form, banca: e.target.value })} className="mt-1" />
          </div>
          <div className="sm:col-span-2">
            <Label>IBAN</Label>
            <Input data-testid="bonifico-iban" value={form.iban || ""}
              onChange={(e) => setForm({ ...form, iban: e.target.value })} className="mt-1 font-mono" />
          </div>
          <div>
            <Label>BIC / SWIFT</Label>
            <Input data-testid="bonifico-bic" value={form.bic_swift || ""}
              onChange={(e) => setForm({ ...form, bic_swift: e.target.value })} className="mt-1 font-mono" />
          </div>
          <div>
            <Label>Email contabile</Label>
            <Input data-testid="bonifico-email" value={form.email_contabile || ""}
              onChange={(e) => setForm({ ...form, email_contabile: e.target.value })} className="mt-1" />
          </div>
          <div className="sm:col-span-2">
            <Label>Causale (template)</Label>
            <Input data-testid="bonifico-causale" value={form.causale_template || ""}
              onChange={(e) => setForm({ ...form, causale_template: e.target.value })}
              className="mt-1" placeholder="Attivazione licenza condominio {nome_condominio}" />
            <p className="text-[10px] text-slate-500 mt-1">Puoi usare la variabile <code>{"{nome_condominio}"}</code> che verrà sostituita al momento del pagamento.</p>
          </div>
          <div className="sm:col-span-2">
            <Label>Note pubbliche</Label>
            <Textarea data-testid="bonifico-note" value={form.note || ""}
              onChange={(e) => setForm({ ...form, note: e.target.value })}
              className="mt-1 min-h-[80px]" />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button data-testid="bonifico-salva" disabled={busy} onClick={salva}
            className="bg-brand hover:bg-brand-dark">
            <Save className="w-4 h-4 mr-1.5" /> {busy ? "Salvo…" : "Salva estremi"}
          </Button>
        </div>
      </Card>
    </div>
  );
}
